import ScrollReveal from 'scrollreveal';

// Theme toggle — persist choice in localStorage
const themeToggle = document.getElementById('theme-toggle');
const htmlEl = document.documentElement;
const savedTheme = localStorage.getItem('theme') || 'light';
htmlEl.setAttribute('data-theme', savedTheme);

themeToggle.addEventListener('click', () => {
  const current = htmlEl.getAttribute('data-theme');
  const next = current === 'dark' ? 'light' : 'dark';
  htmlEl.setAttribute('data-theme', next);
  localStorage.setItem('theme', next);
});

// Name hover — reveal hidden letters on tap (touch devices)
const heroName = document.getElementById('hero-name');
if (heroName) {
  let isTouchRevealed = false;
  heroName.addEventListener('touchstart', (e) => {
    e.preventDefault();
    isTouchRevealed = !isTouchRevealed;
    heroName.classList.toggle('is-revealed', isTouchRevealed);
  }, { passive: false });
}

// Mobile navigation toggle
const hamburger = document.getElementById('hamburger');
const navLinks = document.getElementById('nav-links');

if (hamburger && navLinks) {
  hamburger.addEventListener('click', () => {
    const isOpen = navLinks.classList.toggle('nav__links--mobile-open');
    hamburger.classList.toggle('nav__hamburger--active');
    hamburger.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  navLinks.querySelectorAll('.nav__link').forEach(link => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('nav__links--mobile-open');
      hamburger.classList.remove('nav__hamburger--active');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

// Highlight active nav link based on current page
const currentPath = window.location.pathname;
document.querySelectorAll('.nav__link').forEach(link => {
  link.classList.remove('nav__link--active');
  const linkPath = link.getAttribute('href');

  if (currentPath === linkPath || (currentPath.endsWith('index.html') && linkPath === '/')) {
    link.classList.add('nav__link--active');
  }
});

// Scroll reveal animations
const sr = ScrollReveal({
  origin: 'bottom',
  distance: '20px',
  duration: 600,
  delay: 100,
  easing: 'ease-out',
  reset: false,
  viewFactor: 0.15
});

function initScrollReveals() {
  sr.reveal('.hero__greeting', { delay: 100 });
  sr.reveal('.hero__name', { delay: 200 });
  sr.reveal('.hero__role', { delay: 300 });
  sr.reveal('.hero__subtitle', { delay: 350 });
  sr.reveal('.hero__socials', { delay: 400 });
  sr.reveal('.hero__avatar-wrapper', { delay: 300, origin: 'right' });

  sr.reveal('.section__label', { delay: 100 });
  sr.reveal('.about__content', { delay: 200 });
  sr.reveal('.skills__group', { interval: 100 });
  sr.reveal('.experience__item', { interval: 150 });
  sr.reveal('.project-card', { interval: 150 });
  sr.reveal('.gallery__item', { interval: 100 });
}

// Loading delay for Projects/Gallery pages
const loadingIndicator = document.getElementById('loading-indicator');
const contentContainer = document.getElementById('content-container');

if (loadingIndicator && contentContainer) {
  setTimeout(() => {
    loadingIndicator.style.display = 'none';
    contentContainer.style.display = 'block';
    void contentContainer.offsetWidth; // trigger reflow for transition
    contentContainer.style.opacity = '1';
    initScrollReveals();
  }, 1200);
} else {
  initScrollReveals();
}

// Avatar hover animation (GSAP burst effect)
const avatarContainer = document.getElementById('hero-avatar-container');
if (avatarContainer && typeof gsap !== "undefined") {
  const mainImg = avatarContainer.querySelector('.main-avatar');
  const hiddenImgs = avatarContainer.querySelectorAll('.hidden-img');

  if (mainImg && hiddenImgs.length > 0) {
    let hoverTl = gsap.timeline({ paused: true });

    window.addEventListener('load', () => {
      const mainBox = mainImg.getBoundingClientRect();
      const mainCenterX = mainBox.left + mainBox.width / 2;
      const mainCenterY = mainBox.top + mainBox.height / 2;

      hiddenImgs.forEach((img, i) => {
        gsap.set(img, { opacity: 0 });

        const imgBox = img.getBoundingClientRect();
        const imgCenterX = imgBox.left + imgBox.width / 2;
        const imgCenterY = imgBox.top + imgBox.height / 2;

        const fromX = mainCenterX - imgCenterX;
        const fromY = mainCenterY - imgCenterY;

        hoverTl.fromTo(
          img,
          { opacity: 0, x: fromX, y: fromY, scale: 0.5 },
          { opacity: 1, x: 0, y: 0, scale: 1, duration: 0.8, ease: "back.out(1.7)" },
          i * 0.15
        );

        img.addEventListener("mouseenter", () => {
          gsap.to(img, { scale: 1.2, duration: 0.3, ease: "power1.out" });
        });

        img.addEventListener("mouseleave", () => {
          gsap.to(img, { scale: 1, duration: 0.3, ease: "power1.out" });
        });
      });

      avatarContainer.addEventListener("mouseenter", () => hoverTl.play());
      avatarContainer.addEventListener("mouseleave", () => hoverTl.reverse());
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG' || e.target.closest('.gallery__item')) {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (
      (e.ctrlKey || e.metaKey) && 
      (e.key === 's' || e.key === 'S' || e.key === 'u' || e.key === 'U')
    ) {
      if (window.location.pathname.includes('gallery')) {
        e.preventDefault();
      }
    }
  });
});
